import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#5C728A",
      d: "M12 19.07q-1.467 1.468-3.536 1.468t-3.535-1.467q-1.467-1.467-1.467-3.536T4.929 12L7.05 9.878q.3-.3.708-.3.407 0 .707.3t.3.708q0 .408-.3.707l-2.122 2.121a2.9 2.9 0 0 0-.884 2.121q0 1.237.884 2.122.885.884 2.122.884 1.238 0 2.12-.884l2.122-2.122q.3-.3.708-.3.407 0 .707.3t.3.708q0 .407-.3.707zm-1.414-4.242q-.3.3-.708.3a.96.96 0 0 1-.706-.3q-.3-.3-.3-.708 0-.407.3-.706l4.242-4.243q.3-.3.708-.3t.707.3q.3.3.3.708 0 .407-.3.707zm6.364-.707q-.3.3-.708.3a.96.96 0 0 1-.706-.3q-.3-.3-.3-.708 0-.407.3-.706l2.121-2.122q.885-.884.884-2.12 0-1.239-.884-2.122a2.9 2.9 0 0 0-2.121-.884q-1.237 0-2.122.884l-2.12 2.121q-.301.3-.709.3a.96.96 0 0 1-.706-.3q-.3-.3-.3-.708 0-.407.3-.706L12 4.929q1.467-1.467 3.536-1.468t3.535 1.468q1.467 1.467 1.467 3.536T19.072 12z"
    }, null, -1)
  ]))]))
}
export default { render: render }